import ListingPage from '../../components/ListingPage';
import WhatsappMessagesCards from '../../components/Whatsapp/WhatsappMessagesCards';

const WhatsappMessagesPage = () => {
  return <ListingPage entityType="whatsappMessage" useStats={true} filterBy="name" Cards={WhatsappMessagesCards} />;
};

export default WhatsappMessagesPage;
